(function($, window, document, s, undefined) {

  var initMoreBuyingOptions = function initMoreBuyingOptions() {
    s.$doc.on('click', "#slid", function (){
      $("#choices").slideToggle(400);
    });
  };

  var checkForMoreBuyingOptions = function checkForMoreBuyingOptions (){
    if (s.bodyId !== 'body-product-detail') return;

    initMoreBuyingOptions();
  };

  s.callOnReady(checkForMoreBuyingOptions);

})(jQuery, this, this.document, window.s);
